/* Utility pages (404, /collections), Sunflower sweep Oct 2026. Progressive enhancement only; both pages work without it.
   - 404 on an old product URL: prefill the search with the words from the URL (e.g. "vintage dining chair") and offer it.
   - /collections: jump chips (and a #shop-* hash) open the group they point at; groups start folded on phones.
   - "Ask us" / "Send a photo" open the site chat in place (window.WNFChatOpen); without it the links go to /pages/chat.
   - Consent-gated GA4: wnf_utility_cta_click {page_kind, cta_placement}, wnf_utility_chat_open {page_kind, intent}. */
(() => {
  'use strict';
  if (window.wnfswuInitialized) return;
  window.wnfswuInitialized = true;
  const measurementId = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, { send_to: measurementId, ...params });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const STOP = new Set(['consigned', 'consignment', 'portland', 'oregon', 'whats', 'new', 'furniture', 'lhf', 'rhf', 'the', 'and', 'with', 'in', 'of', 'for', 'a', 'w']);
  const wordsFromPath = (path) => {
    const handle = decodeURIComponent((path.split('/products/')[1] || '').split(/[/?#]/)[0]);
    return handle.split('-').filter((w) => w.length > 1 && !/\d/.test(w) && !STOP.has(w.toLowerCase())).slice(0, 4).join(' ');
  };
  const money = (v) => '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const card = (p) => {
    const art = document.createElement('article'); art.className = 'wnfs-product-card';
    const a = document.createElement('a'); a.className = 'wnfs-product-image'; a.href = p.url; a.dataset.wnfswuCta = 'like-product';
    const img = document.createElement('img');
    const src = (p.featured_image && p.featured_image.url) || p.image || '';
    const sep = src.includes('?') ? '&' : '?';
    img.src = src + sep + 'width=600'; img.srcset = src + sep + 'width=300 300w, ' + src + sep + 'width=600 600w';
    img.sizes = '(max-width: 700px) 45vw, 23vw'; img.width = 600; img.height = 600; img.loading = 'lazy'; img.alt = p.title || '';
    a.append(img);
    const info = document.createElement('div'); info.className = 'wnfs-product-info';
    const h3 = document.createElement('h3'); const t = document.createElement('a'); t.href = p.url; t.textContent = p.title || ''; h3.append(t);
    const price = document.createElement('p');
    price.textContent = (/modular/i.test(p.title || '') ? 'Modules from ' : Number(p.price_max) > Number(p.price_min) ? 'From ' : '') + money(p.price_min || p.price);
    info.append(h3, price); art.append(a, info);
    return art;
  };
  const fillLike = (slot, q, root, kind) => {
    let done = false;
    const fallback = () => {
      if (done) return; done = true;
      const picks = root.querySelector('[data-wnfswu-picks]');
      if (picks) slot.replaceWith(picks); else slot.remove();
    };
    if (!q || !window.fetch) return fallback();
    const timer = setTimeout(fallback, 3000);
    const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const url = base + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((d) => {
        const all = (((d || {}).resources || {}).results || {}).products || [];
        const ok = all.filter((p) => p.available !== false && Number(p.price_min || p.price) >= 100 && Number(p.price_max || p.price) <= 3 * Number(p.price_min || p.price));
        if (done) return;
        if (ok.length < 2) return fallback();
        clearTimeout(timer); done = true;
        slot.querySelector('[data-wnfswu-like-grid]').replaceChildren(...ok.slice(0, 4).map(card));
        const more = slot.querySelector('[data-wnfswu-like-all]');
        if (more) more.href = base + 'search?type=product&q=' + encodeURIComponent(q);
        track('wnf_utility_like_shown', { page_kind: kind, count: Math.min(ok.length, 4) });
      })
      .catch(fallback);
  };
  const init = () => {
    const root = document.querySelector('.wnfswu[data-wnfsw-utility-page]');
    if (!root) return;
    const kind = root.hasAttribute('data-wnfsw-404-page') ? '404' : 'collections';
    if (root.hasAttribute('data-wnfswu-product-path')) {
      const q = wordsFromPath(location.pathname);
      const input = root.querySelector('[data-wnfswu-q]');
      if (q && input && !input.value) input.value = q;
      const slot = root.querySelector('[data-wnfswu-like]');
      if (slot) fillLike(slot, q, root, kind);
    }
    const openGroup = (id) => { const d = id && root.querySelector('details' + id); if (d) d.open = true; };
    if (location.hash.startsWith('#shop-')) openGroup(location.hash);
    root.querySelectorAll('a[href^="#shop-"]').forEach((a) => a.addEventListener('click', () => openGroup(a.getAttribute('href'))));
    document.addEventListener('click', (event) => {
      const cta = event.target.closest('[data-wnfswu-cta]');
      if (cta && root.contains(cta)) track('wnf_utility_cta_click', { page_kind: kind, cta_placement: cta.dataset.wnfswuCta, transport_type: 'beacon' });
      const chat = event.target.closest('[data-wnfswu-chat]');
      if (chat && root.contains(chat) && typeof window.WNFChatOpen === 'function') {
        event.preventDefault();
        const intent = chat.dataset.wnfswuChat === 'photo' ? 'photo' : '';
        window.WNFChatOpen(intent ? { intent } : undefined);
        track('wnf_utility_chat_open', { page_kind: kind, intent: intent || 'ask' });
      }
    }, true);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
